import {Loader} from '@mantine/core';
import {isReleasedRedesignRecruitment} from '../../../../config/unReleasePage';
import {RECRUITMENT_SCHEDULE_WARNING_CODE} from '../../../../core/entities/recruitment/constants';
import type {
  Recruitment,
  RecruitmentScheduleWarning,
} from '../../../../core/entities/recruitment/schema';
import {RecruitmentItemForDetail} from '../Container/Presenter/RecuritmentItemForDetail';
import {RecruitmentList} from './RecruitmentList';

export const OtherRecruitmentList: React.FC<{
  companyName: string;
  scheduleWarning: RecruitmentScheduleWarning;
  otherRecruitmentList: Recruitment[];
  isLoadingOtherRecruitmentList: boolean;
  hasOtherRecruitmentList: boolean;
  otherRecruitmentListRef: React.RefObject<HTMLDivElement>;
}> = ({
  companyName,
  scheduleWarning,
  otherRecruitmentList,
  isLoadingOtherRecruitmentList,
  hasOtherRecruitmentList,
  otherRecruitmentListRef,
}) => {
  const TITLE_TEXT =
    scheduleWarning.code === RECRUITMENT_SCHEDULE_WARNING_CODE.OK
      ? `他の公開中の${companyName}の募集情報`
      : '公開中の募集情報';

  if (isReleasedRedesignRecruitment()) {
    return (
      <div ref={otherRecruitmentListRef}>
        <RecruitmentList
          title={TITLE_TEXT}
          recruitments={otherRecruitmentList}
        />
      </div>
    );
  }

  return isLoadingOtherRecruitmentList ? (
    <div className="w-full h-[150px] flex justify-center items-center">
      <Loader color="gray" />
    </div>
  ) : (
    hasOtherRecruitmentList && otherRecruitmentList && (
      <div ref={otherRecruitmentListRef} className="mt-16">
        <h2 className="bg-primary-1 p-12 text-white text-md leading font-bold">
          {TITLE_TEXT}
        </h2>
        <div className="bg-white p-16">
          <h3 className="bg-background-1 p-8 text-md text-black leading font-bold">
            募集情報
          </h3>
          <div className="bg-white mt-12">
            {otherRecruitmentList.map((recruitment) => {
              return <RecruitmentItemForDetail recruitment={recruitment} />;
            })}
          </div>
        </div>
      </div>
    )
  );
};
